import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setPostLiftingIssue = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_ISSUE_LIFTING
            });
            dispatch(Action.SetGetUserById(params.id))
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostLiftingIssue as SetPostLiftingIssue
}